import { Component, ChangeDetectionStrategy } from '@angular/core';
// scanner-disable-next-line R7 -- fetches the static assets/commit_messages.txt; the interceptor deliberately skips assets/ URLs
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReleaseNotesComponent {
  commitMessagesHtml: string | null = null;
  showModal: boolean = false;
  visible: boolean = true;

  private readonly jiraBaseUrl = 'https://sensika.atlassian.net/browse/';
  private readonly ticketPattern = /\b((?:WAP|SEN)-\d+)\b/g;

  constructor(private http: HttpClient) {}

  loadCommitMessages() {
    this.http
      .get('assets/commit_messages.txt', { responseType: 'text' })
      .subscribe(
        (data) => {
          this.commitMessagesHtml = this.linkifyTickets(data);
          this.showModal = true;
        },
        (error) => {
          console.error('There was an error!', error);
        },
      );
  }

  private linkifyTickets(text: string): string {
    const escaped = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    return escaped.replace(
      this.ticketPattern,
      (match) =>
        `<a href="${this.jiraBaseUrl}${match}" target="_blank" rel="noopener noreferrer">${match}</a>`,
    );
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  close() {
    this.visible = false;
  }
}
